import {Component, ElementRef, OnInit} from '@angular/core';
import {ApiService} from '../api.service';
import {User} from '../user';
import {Stats} from '../stats';
import {Postcard} from '../postcard';
import {MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {ChangeUserComponent} from '../change-user/change-user.component';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  user: User = <User>{};
  stats: Stats = {postcards_uploaded: 0, total_transcribed: 0, postcards_reported: 0, transcripts_reported: 0, total_reported: 0};

  tab = 'activity';
  postcards: Postcard[];
  users: any;
  reports: Observable<Array<Postcard>> = null;
  changeRoleDialog: MatDialogRef<ChangeUserComponent>;
  reported = false;

  constructor(private api: ApiService, private el: ElementRef, private dialog: MatDialog, private snackbar: MatSnackBar) {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.tab = localStorage.getItem('tab');
    if (this.tab !== null) {
      switch (this.tab) {
        case 'activity':
          this.displayActivity();
          break;
        case 'users':
          this.displayUsers();
          break;
        case 'reports':
          this.displayReports();
          break;
      }
    } else {
      this.displayActivity();
    }
  }

  ngOnInit() {}

  displayActivity = function() {
    // this.user.user_id
    this.tab = 'activity';
    localStorage.setItem('tab', this.tab);

    // get all the other stats from our database
    this.api.getUserMetrics(this.user.user_id).subscribe(
      res => {
        this.postcards = res[0].postcards;
        this.stats = res[0].stats;
        res[0].stats.forEach(element => {
          if (`${element.type}` === 'add_postcard') {
            this.stats.postcards_uploaded = element.total;
          } else if (`${element.type}` === 'add_transcript') {
            this.stats.total_transcribed = element.total;
          } else if (`${element.type}` === 'report_transcript') {
            this.stats.transcripts_reported = element.total;
          } else if (`${element.type}` === 'report_postcard') {
            this.stats.postcards_reported = element.total;
          } else {
            console.warn('no stats found!');
          }
        });
      }
    );
  };

  displayUsers = function() {
    this.tab = 'users';
    localStorage.setItem('tab', this.tab);
    this.api.getUsers().subscribe(
      res => {
        this.users = res;
      }
    );
  };

  displayReports = function() {
    // JSON.parse(localStorage.getItem('user')).user_id
    this.tab = 'reports';
    localStorage.setItem('tab', this.tab);
    this.api.getFlaggedPostcards().subscribe(
      res => {
        if (res.length !== 0) {
          this.reports = res;
        }
      }
    );
  };

  updateUrl = function (event) {
    event.srcElement.src = this.url + 'postcard_holder.png';
  };

  changeUserRole = function(id) {
    if (!this.reported) {
      this.reported = true;
      this.changeRoleDialog = this.dialog.open(ChangeUserComponent, {
        hasBackdrop: true
      });

      this.changeRoleDialog.afterClosed().subscribe(
        selectedOption => {
          if (selectedOption != null) {

            this.users.filter((val: any) => {
              if (val.user_id === id) {
                val.user_role = selectedOption;
              }
            });

            this.api.updateUserRole(id, selectedOption).subscribe(
                this.snackbar.open('Role updated', 'OK', {
                  duration: 1500,
                })
            );
          }

          // allow the report button to be pressed again
          this.reported = false;

          // remove the focus
          this.el.nativeElement.querySelector('.cdk-program-focused').classList.remove('cdk-program-focused');
        });
    }
  };

  changeSource = function(event) {
    event.target.src = 'assets/images/person_placeholder.png';
  };
}
